export const HIGHLIGHT_CONTENT_MAX_LENGTH = 200;

export enum HAQAction {
  AddQuestion = "ADD_QUESTION",
  ChangeStatus = "CHANGE_STATUS",
  CreateRelatedQuestion = "CREATE_RELATED_QUESTION",
  SendCopyToSponsor = "SEND_COPY_TO_SPONSOR",
  SubmitToHA = "SUBMIT_TO_HA",
  SetToComplete = "SET_TO_COMPLETE",
  SetToFinal = "SET_TO_FINAL",
  SetToDraft = "SET_TO_DRAFT",
  Export = "EXPORT",
  Delete = "DELETE",
  Edit = "EDIT",
  ChangeDueDate = "CHANGE_DUE_DATE",
  ViewSubmissionHistory = "VIEW_SUBMISSION_HISTORY",
  View = "VIEW",
  AddResponse = "ADD_RESPONSE",
}

export enum HAQFieldName {
  Content = "content",
  ResponseContent = "responseContent",
  ReferenceNumber = "referenceNumber",
  Domain = "domain",
  Topic = "topic",
  AdditionalInstructions = "additionalInstructions",
  DueDate = "dueDate",
  HAQWithContent = "HAQWithContent",
  HAQResponseWithContent = "HAQResponseWithContent",
  Assets = "assets",
  ContentReference = "contentReference",
  QuestionType = "questionType",
  HAOrganization = "HAOrganization",
}

export enum HAQStatus {
  Draft = "DRAFT",
  InReview = "IN_REVIEW",
  Reviewed = "REVIEWED",
  Final = "FINAL",
  Submitted = "SUBMITTED",
  Sent = "SENT",
}

export enum HAQEffectiveStatus {
  AvailableToSubmit = "AVAILABLE_TO_SUBMIT",
  AwaitingResponse = "AWAITING_RESPONSE",
  ResponseReceived = "RESPONSE_RECEIVED",
  Submitted = "SUBMITTED",
  Completed = "COMPLETED",
}
